import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
import { ListDataIgnoreDate } from '../../@types/tour';

const initialState: ListDataIgnoreDate = {
  tour: false,
  showExtendedAttributes: false,
};

const listDataIgnoreDateSlice = createSlice({
  name: 'listDataIgnoreDates',
  initialState,
  reducers: {
    setTourValue(state, action) {
      state.tour = action.payload;
    },
    setShowExtendedAttributes(state, action) {
      state.showExtendedAttributes = action.payload;
    },
  },
});

export default listDataIgnoreDateSlice.reducer;

export function setListDataIgnoreDatesTour(value: boolean) {
  dispatch(listDataIgnoreDateSlice.actions.setTourValue(value));
}

export function setShowExtendedAttributes(value: boolean) {
  dispatch(listDataIgnoreDateSlice.actions.setShowExtendedAttributes(value));
}
